<template>
  <div class="headerNav">
    <van-nav-bar
      :fixed="isFixed"
      :style="{ background: bgColor }"
      :title="title"
      :zIndex="1001"
      :right-text="right"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :class="isShadow ? 'pageHealthCareShadow' : ''"
    >
      <template #left>
        <i class="iconfont iconjiantou1"> </i>
        <!-- <span class="back">&nbsp;返回</span> -->
      </template>
      <template #right v-if="!right">
        <slot name="right" />
      </template>
      <template #title v-if="!title">
        <slot name="title" />
      </template>
    </van-nav-bar>
    <!-- <div :class="show ? 'divList' : 'div'"></div> -->
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: "",
    },
    right: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "var(--depYelColor)",
    },
    isShadow: {
      type: Boolean,
      default: () => true,
    },
    isFixed: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$go(-1);
    },
    onClickRight() {
      this.$emit("handle");
    },
  },
};
</script>

<style scoped lang="less">
.headerNav {
  height: 46px;
  /deep/.van-nav-bar {
    color: #fff;
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title,
    a {
      color: inherit;
      vertical-align: middle;
    }
    .van-nav-bar__title {
      font-size: 18px;
    }
    .van-icon,
    .iconfont {
      font-size: 24px;
      vertical-align: middle;
    }
    .iconcirclearrowleft {
      font-size: 22px;
    }
    .iconjiantou1 {
      font-size: 26px;
    }
    .back {
      font-size: 16px;
      display: inline-block;
      margin-top: 2px;
      margin-left: 5px;
    }
  }
  .van-nav-bar::after {
    content: "";
    border: none;
  }
  .div {
    height: 46px;
    margin-bottom: 20px;
  }
  .divList {
    height: 46px;
    margin-bottom: 0px;
  }
}
</style>
